// 動画プレイヤーの音量設定をブラウザ側（localStorage）に保存する。
// 動画単位ではなく、再生ページ全体で共通の設定として扱う。
const VOLUME_STORAGE_KEY = 'player_volume';
const MUTED_STORAGE_KEY = 'player_muted';

export const DEFAULT_VOLUME = 1;

function clampVolume(value) {
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return null;
  return Math.min(1, Math.max(0, numeric));
}

function getStorage() {
  try {
    return typeof localStorage !== 'undefined' ? localStorage : null;
  } catch {
    // プライベートモード等で localStorage 参照自体が例外になる環境がある
    return null;
  }
}

// 保存済みの設定がない（または壊れている）場合は null を返し、呼び出し側でデフォルトを使う
export function loadStoredVolume() {
  const storage = getStorage();
  if (!storage) return null;

  try {
    const volume = clampVolume(storage.getItem(VOLUME_STORAGE_KEY));
    if (volume === null) return null;
    return { volume, isMuted: storage.getItem(MUTED_STORAGE_KEY) === 'true' };
  } catch (err) {
    console.warn('Failed to read stored player volume', err);
    return null;
  }
}

export function saveStoredVolume({ volume, isMuted }) {
  const storage = getStorage();
  if (!storage) return;

  const normalized = clampVolume(volume);
  if (normalized === null) return;

  try {
    storage.setItem(VOLUME_STORAGE_KEY, String(normalized));
    storage.setItem(MUTED_STORAGE_KEY, isMuted ? 'true' : 'false');
  } catch (err) {
    console.warn('Failed to persist player volume', err);
  }
}
